<!--
 * @Description: 调代课申请 详情
 * @Author: PF
 * @Date: 2023-07-21 11:10:39.999
 * @LastEditors: PF
 * @LastEditTime: 2024-03-19 17:47:27
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions class="descript-box" :column="4" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="申请时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.sqsj}}</el-descriptions-item>
        <el-descriptions-item label="开始时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.kssj}}</el-descriptions-item>
        <el-descriptions-item label="结束时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.jssj}}</el-descriptions-item>
        <el-descriptions-item label="类型" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in tdklxData.list" :key="index">
            <span v-if="ruleForm.tdklx === item.value">{{ item.name }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in tdkztData.list" :key="index">
            <span v-if="ruleForm.zt === item.value">{{ item.name }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="原因" label-align="right" align="left" width="120px" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.yy"></p>
        </el-descriptions-item>
        <el-descriptions-item label="" label-align="right" align="left" width="120px" span="4"></el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'
import { gettdkzt } from '@/utils/meiju'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

const tdkztData = ref({ list: [] }) // 加载 调代课状态 下拉框
const tdklxData = ref({ list: [] }) // 加载 调代课类型 下拉框
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      tdkztData.value = gettdkzt()
      loadSelect({ url: '/api/v2/jiaowu/tiaodaikeshenqing/tiaodaikeleixing', data: tdklxData })
      loadData({ url: '/api/v2/jiaowu/tiaodaikeshenqing/' + props.row.id, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
